import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  '& > .MuiButtonBase-root': {
    fontSize: 12,
    padding: '4px 8px',
    textTransform: 'none',
  },
});

export default StyledBox;
